import apiClient from './apiClient';

function unwrap(error, fallback) {
  const err = error.response?.data;
  return new Error(err?.error || fallback);
}

class ProjectSharingService {
  // Members
  async getMembers(projectId) {
    try {
      return await apiClient.get(`/projects/${projectId}/members`);
    } catch (e) { throw unwrap(e, 'Failed to load members'); }
  }

  async removeMember(projectId, userId) {
    try {
      return await apiClient.delete(`/projects/${projectId}/members/${userId}`);
    } catch (e) { throw unwrap(e, 'Failed to remove member'); }
  }

  // Activity
  async getActivity(projectId) {
    try {
      return await apiClient.get(`/projects/${projectId}/activity`);
    } catch (e) { throw unwrap(e, 'Failed to load activity'); }
  }

  // Shareable users (active users not already in the project / with an open invite)
  async getShareableUsers(projectId) {
    try {
      return await apiClient.get(`/projects/${projectId}/shareable_users`);
    } catch (e) { throw unwrap(e, 'Failed to load users'); }
  }

  // Project-scoped invitations
  async listProjectInvitations(projectId) {
    try {
      return await apiClient.get(`/projects/${projectId}/invitations`);
    } catch (e) { throw unwrap(e, 'Failed to load invitations'); }
  }

  async createInvitation(projectId, inviteeId) {
    try {
      return await apiClient.post(`/projects/${projectId}/invitations`, { invitee_id: inviteeId });
    } catch (e) { throw unwrap(e, 'Failed to send invitation'); }
  }

  // Top-level invitation feeds
  async getIncoming() {
    try {
      return await apiClient.get('/invitations/incoming');
    } catch (e) { throw unwrap(e, 'Failed to load invitations'); }
  }

  async getPendingApproval() {
    try {
      return await apiClient.get('/invitations/pending_approval');
    } catch (e) { throw unwrap(e, 'Failed to load pending approvals'); }
  }

  async getOutgoing() {
    try {
      return await apiClient.get('/invitations/outgoing');
    } catch (e) { throw unwrap(e, 'Failed to load outgoing invitations'); }
  }

  // Per-invitation actions
  async accept(invitationId)      { return this._action(invitationId, 'accept'); }
  async reject(invitationId)      { return this._action(invitationId, 'reject'); }
  async approve(invitationId)     { return this._action(invitationId, 'approve'); }
  async ownerReject(invitationId) { return this._action(invitationId, 'owner_reject'); }
  async cancel(invitationId)      { return this._action(invitationId, 'cancel'); }

  async _action(invitationId, action) {
    try {
      return await apiClient.post(`/invitations/${invitationId}/${action}`);
    } catch (e) { throw unwrap(e, `Failed to ${action} invitation`); }
  }
}

export const projectSharingService = new ProjectSharingService();